@switch (type()) {
  @case ('success') {
    <div
      class="toast border-green-600 relative">
      <div class="flex w-full justify-between">
        <div class="flex">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 17" fill="currentColor"
                 class="w-10 h-10 text-green-600 pr-1">
              <path fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                    clip-rule="evenodd"/>
            </svg>
          </div>
          <div>
            <div class="font-bold">Success</div>
            <div class="toast-message">
              {{ message() }}
            </div>
          </div>
        </div>
        <div class="flex">
          <button class="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500" aria-label="close"
                  (click)="close()">
            <svg class="w-5 h-5" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                 viewBox="0 0 20 20" stroke="currentColor">
              <path d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  }
  @case ('error') {
    <div
      class="toast border-red-600">
      <div class="flex w-full justify-between">
        <div class="flex">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 17" fill="currentColor"
                 class="w-10 h-10 text-red-600 pr-1">
              <path fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z"
                    clip-rule="evenodd"/>
            </svg>
          </div>
          <div>
            <div class="font-bold">Error</div>
            <div class="toast-message">
              {{ message() }}
            </div>
          </div>
        </div>
        <div class="flex">
          <button class="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500" aria-label="close"
                  (click)="close()">
            <svg class="w-5 h-5" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                 viewBox="0 0 20 20" stroke="currentColor">
              <path d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  }
  @case ('info') {
    <div
      class="toast border-gray-600">
      <div class="flex w-full justify-between">
        <div class="flex">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 17" fill="currentColor"
                 class="w-10 h-10  text-gray-500 pr-1">
              <path fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z"
                    clip-rule="evenodd"/>
            </svg>
          </div>
          <div>
            <div class="font-bold">Info</div>
            <div class="toast-message">
              {{ message() }}
            </div>
          </div>
        </div>
        <div class="flex">
          <button class="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500" aria-label="close"
                  (click)="close()">
            <svg class="w-5 h-5" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                 viewBox="0 0 20 20" stroke="currentColor">
              <path d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  }
}
